// Module
var code = "<div class=\"not-found\"> <div class=\"container py-5\"> <div class=\"text-center\"> <h1 class=\"\"> 404 </h1> <h3 class=\"mb-5\"> Page not found </h3> <a href=\"/\" class=\"btn btn-primary text-uppercase\"> <b> Go to home </b> </a> </div> </div> </div> ";
// Exports
export default code;